import { render, staticRenderFns } from "./successModal.vue?vue&type=template&id=477f7e04"
import script from "./successModal.vue?vue&type=script&lang=js"
export * from "./successModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports